export default [
  {
    path: '/mozgo-party/',
    name: 'mozgo-party',
    component: () => import(/* webpackChunkName: "mozgo-party" */ '../views/mozgo-party/mozgo-party.vue'),
    redirect: () => {
      window.location = 'https://party.mozgo.com/';
    },
    meta: {
      layout: '',
      mode: '',
      title: '',
      metaTags: [{
        name: '',
        value: '',
      }],
    },
  },
];
